<script>
import Layout from "@/router/layouts/auth";
import { mapState, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import Password from "@/components/widgets/input-password";

export default {
  components: {
    Layout,
    Password,
  },
  data() {
    return {
      personNumberMask: "###.###.###-##",
      personNumber: "",
      password: "",
      loading: false,
      submitted: false,
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
  },
  validations: {
    personNumber: { required },
    password: { required, minLength: minLength(6) },
  },
  created() {
    this.logout();
  },
  methods: {
    ...mapActions("account", ["regionalUserLogin", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.alert.type = "";
      this.alert.message = "";
      this.loading = true;
      this.regionalUserLogin({
        personNumber: this.personNumber,
        password: this.password,
      });
    },
  },
  watch: {
    "alert.type": function(alert) {
      if (alert == "alert-danger") {
        this.loading = false;
      }
    },
    personNumber(value) {
      this.personNumberMask = value.length <= 14 ? "###.###.###-##" : "##.###.###/####-##";
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 pb-2 text-center">
          <router-link class="align-middle" tag="a" to="/login">
            <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <div class="mb-4">
            <h4 class="mb-1">Acesso de Secretaria</h4>
            <p class="text-muted mb-0">Entre com o acesso criado pela regional.</p>
          </div>

          <b-form @submit.prevent="handleSubmit">
            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ alert.message }}
            </div>

            <b-form-group label="CPF" label-for="personNumber">
              <b-form-input
                v-model="personNumber"
                type="text"
                :class="{ 'is-invalid': submitted && $v.personNumber.$error }"
                v-mask="personNumberMask"
              ></b-form-input>
              <div v-if="submitted && !$v.personNumber.required" class="invalid-feedback">
                O CPF e obrigatorio.
              </div>
            </b-form-group>

            <b-form-group label="Senha" label-for="password">
              <Password v-model="password" :v="$v.password"></Password>
            </b-form-group>

            <div class="mt-4">
              <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                Entrar
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
            </div>
          </b-form>

          <div class="text-center py-5">
            <router-link tag="a" to="/login" class="text-muted">
              Voltar para o login principal
            </router-link>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block"></div>
    </div>
  </Layout>
</template>
